/**
 * Runtime configuration accessor.
 *
 * Values are injected at container start via `/env.js`, which sets
 * `window._env_` before the application bundle executes (see
 * `public/env.js` and the docker entrypoint script). When a value is
 * absent there (e.g. local `npm start`), we fall back to the build-time
 * `process.env.REACT_APP_*` values provided by CRA from `.env` files.
 */

/* eslint-disable no-underscore-dangle */

type RuntimeEnv = {
  REACT_APP_AFFILIATE_NAME?: string;
  REACT_APP_ASSET_API_URL?: string;
  REACT_APP_WMTS_URL?: string;
  REACT_APP_START_LAT?: string;
  REACT_APP_START_LONG?: string;
  REACT_APP_DEFAULT_ZOOM_LEVEL?: string;
};

declare global {
  interface Window {
    _env_?: RuntimeEnv;
  }
}

const runtimeEnv: RuntimeEnv = (typeof window !== 'undefined' && window._env_) || {};

function pick(runtime: string | undefined, buildTime: string | undefined): string {
  if (runtime !== undefined && runtime !== '') {
    return runtime;
  }

  return buildTime ?? '';
}

export const AFFILIATE_NAME: string = pick(
  runtimeEnv.REACT_APP_AFFILIATE_NAME,
  process.env.REACT_APP_AFFILIATE_NAME,
);

export const ASSET_API_URL: string = pick(
  runtimeEnv.REACT_APP_ASSET_API_URL,
  process.env.REACT_APP_ASSET_API_URL,
);

export const WMTS_URL: string = pick(
  runtimeEnv.REACT_APP_WMTS_URL,
  process.env.REACT_APP_WMTS_URL,
);

export const START_LAT: number = Number(pick(
  runtimeEnv.REACT_APP_START_LAT,
  process.env.REACT_APP_START_LAT,
));

export const START_LONG: number = Number(pick(
  runtimeEnv.REACT_APP_START_LONG,
  process.env.REACT_APP_START_LONG,
));

export const DEFAULT_ZOOM_LEVEL: number = Number(pick(
  runtimeEnv.REACT_APP_DEFAULT_ZOOM_LEVEL,
  process.env.REACT_APP_DEFAULT_ZOOM_LEVEL,
));
